import cogoToast from "cogo-toast";

export const niceDateTime = (date) => {
  return new Date(date).toLocaleTimeString("en-IN", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
export const niceDate = (date) => {
  return new Date(date).toLocaleDateString("en-IN", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const niceFileSize = (inputValue) => {
  if (!inputValue) return "";

  if (inputValue === 0) return "0 Bytes";

  const units = ["bytes", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"];

  const decimal = 2;

  const baseValue = 1024;

  const number = Number(inputValue);

  const index = Math.floor(Math.log(number) / Math.log(baseValue));

  const fm = `${parseFloat((number / baseValue ** index).toFixed(decimal))} ${
    units[index]
  }`;

  return fm;
};

export const isInPastDate = (date, compareDate = new Date()) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion >= 0) {
    // compareDate or Future
    return true;
  } else {
    return false;
  }
};
export const isInPastDateStrict = (date, compareDate = new Date()) => {
  // if date in question is in the past wrt compareDate return true.
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion > 0) {
    // Future
    return true;
  } else {
    return false;
  }
};

export const isInFutureDate = (date, compareDate = new Date()) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion <= 0) {
    // compareDate or Future
    return true;
  } else {
    return false;
  }
};
export const isInFutureDateStrict = (date, compareDate = new Date()) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date(compareDate);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);
  if (compareTo - dateInQuestion < 0) {
    // Future
    return true;
  } else {
    return false;
  }
};

export const isDateToday = (date) => {
  let dateInQuestion = new Date(date);
  let compareTo = new Date();
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion === 0) {
    return true;
  } else {
    return false;
  }
};
export const areTwoDatesSame = (d1, d2) => {
  let dateInQuestion = new Date(d1);
  let compareTo = new Date(d2);
  compareTo.setHours(0, 0, 0, 0);
  dateInQuestion.setHours(0, 0, 0, 0);

  if (compareTo - dateInQuestion === 0) {
    return true;
  } else {
    return false;
  }
};

export const copyToClipboard = (text) => {
  // Try the Clipboard API first
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }

  // Fallback to a temporary textarea element
  const tempTextarea = document.createElement("textarea");
  tempTextarea.value = text;
  document.body.appendChild(tempTextarea);
  tempTextarea.select();
  document.execCommand("copy");
  document.body.removeChild(tempTextarea);
  return Promise.resolve();
};
